import React, { useRef, useState, useEffect } from 'react';
import { setHoveredSearchResult } from '../../../store/actions';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { ILokalplan } from '../../../Interfaces/ILokalplan';
import { common } from '../../../style';
import { neutral } from '../../../style/colors';
import { getAnvgenForKode } from '../../Map/util/koder';
import { usePrevious } from '../../../hooks/usePrevious';
import AnvGenContainer from './AnvGenContainer';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
import Delomraade from '../../common/Icons/Light/Delomraade';
import Byggefelt from '../../common/Icons/Light/Byggefelt';

const SearchResult = (props: ISearchResultProps) => {
  const { lokalplan, onClick, hovered, setHovered } = props;
  const ref = useRef(null);
  const [disableScroll, setDisableScroll] = useState(false);
  const previousHovered = usePrevious(hovered);

  useEffect(() => {
    if (!disableScroll && hovered && !previousHovered) {
      scrollIntoView(ref.current, {
        scrollMode: 'if-needed',
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  }, [disableScroll, hovered, previousHovered]);
  const { planid } = lokalplan.feature.properties;
  return (
    <Wrapper
      hovered={hovered}
      onMouseOver={() => {
        setDisableScroll(true);
        setHovered(planid);
      }}
      onClick={onClick ? () => onClick(lokalplan) : () => { }}
      onMouseOut={() => {
        setDisableScroll(false);
        setHovered(-1);
      }}
      ref={ref}
    >
      <h2>{planid}</h2>
      <h1 title={lokalplan.feature.properties.plannavn}>
        {lokalplan.feature.properties.plannavn}
      </h1>
      <InfoRow>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <AnvGenContainer anvgen={lokalplan.feature.properties.anvgen} />
          <span style={{ marginLeft: 5 }}>
            {lokalplan.feature.properties.anvgen
              ? getAnvgenForKode(lokalplan.feature.properties.anvgen).tekst
              : 'Ukendt anvendelse'}
          </span>
        </div>
        <div style={{ display: 'flex' }}>
          <IconWrapper title={`${lokalplan.delomraader.length} delområder`}>
            <Delomraade />
            <span>{lokalplan.delomraader.length}</span>
          </IconWrapper>
          <IconWrapper title={`${lokalplan.byggefelter.length} byggefelter`}>
            <Byggefelt />
            <span>{lokalplan.byggefelter.length}</span>
          </IconWrapper>
        </div>
      </InfoRow>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  cursor: pointer;
  margin: 5px;
  padding: 10px 15px;
  width: 95%;
  height: 120px;
  background-color: ${common.backgroundColor};
  border: 1px solid ${common.backgroundColor};

  ${props =>
    props.hovered &&
    css`
      box-shadow: ${common.boxShadow};
      border-color: ${neutral[900]};
      background-color: #ffffff;

    `}
  h1 {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 18px;
  }
  h2 {
    font-size: 15px;
    margin: 8px 0 0;
  }
  * {
    pointer-events: none;
  }
`;
const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.05em;
`;
const IconWrapper = styled.span`
  display: flex;
  height: 20px;
  width: 45px;
  align-items: center;
  justify-content: space-evenly;
  margin-left: 10px;
`;
const mapStateToProps = (state, ownProps) => {
  return {
    hovered:
      ownProps.lokalplan.feature.properties.planid ===
      state.searchResult.hovered,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setHovered: planid => {
      dispatch(setHoveredSearchResult(planid));
    },
  };
};

interface ISearchResultProps {
  lokalplan: ILokalplan;
  hovered: Boolean;
  setHovered: Function;
  onClick: Function;
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResult);
